import { Component } from "ecsy";

export default class InteractiveComponent extends Component {
  public colorIndex: number = 0; // unique value to determine if this is a clicked entity

  public reset() {
    this.colorIndex = 0;
  }
}
